import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import App from './App.jsx';
import SummonPage from './pages/SummonPage.jsx';
import BrowsePage from './pages/BrowsePage.jsx';
import CartPage from './pages/CartPage.jsx';
import AdminDashboard from './pages/AdminDashboard.jsx';
import AdminPage from './pages/AdminPage.jsx';
import LoginPage from './pages/LoginPage.jsx';
import PrivacyPolicy from './pages/PrivacyPolicy.jsx';
import Terms from './pages/Terms.jsx';
import Returns from './pages/Returns.jsx';
import Shipping from './pages/Shipping.jsx';



import Layout from './components/Layout.jsx';
import { CartProvider } from './context/CartContext.jsx';
import { AuthProvider } from './context/AuthContext.jsx';

import reportWebVitals from './reportWebVitals.js';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <AuthProvider>
      <CartProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<App />} />
              <Route path="summon" element={<SummonPage />} />
              <Route path="browse" element={<BrowsePage />} />
              <Route path="cart" element={<CartPage />} />
              <Route path="admin-dashboard" element={<AdminDashboard />} />
              <Route path="/admin/:id" element={<AdminPage />} />
              <Route path="login" element={<LoginPage />} />
              <Route path="privacy" element={<PrivacyPolicy />} />
              <Route path="terms" element={<Terms />} />
              <Route path="returns" element={<Returns />} />
              <Route path="shipping" element={<Shipping />} />
              {/* Fallback */}
              <Route path="*" element={<Navigate to="/browse" />} />
            </Route>
          </Routes>
        </Router>
      </CartProvider>
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();
